import moment from 'moment'

export const sizePerPageList = [
    { text: '100', value: 100 },
    { text: '200', value: 200 },
    { text: '500', value: 500 },
];

const defaultFilter = {
    filter: {
        branch_uuid: '',
        donation_item_project: '',
        donation_item_type: '',
        donor_name: '',
        donor_id: '',
        donor_city: '',
        channel_type: '',
        channel_uuid: '',
        start_date: moment().subtract(1, 'months'),
        end_date: moment(),
        user_uuid: '',
        donor_uuid: '',
        total_amountlt: '',
        total_amountgt: '',
        bank_message: '',
        channel_trx_id: '',
        donation_item_program: '',
        department: '',
        bank: "",
        tipe_channel: "",
        reconcile_status: null,
        payment_type: "",
        date: "",
        status: "NOT_VOID",
        bank_pooling: null,
        bank_account_uuid: null

        // total_amount: ''
    },
    pageNumber: 1,
    pageSize: 500,
}
export const initialFilter = defaultFilter;

export const badge = (status) => {
    let data = {};
    switch (status) {
        case 'VOID':
            data = { type: 'danger' };
            break;
        case 'REQUEST_VOID':
            data = { type: 'warning' };
            break;
        case 'SETTLE':
            data = { type: 'success' };
            break;
        default:
            data = { type: 'info' };

    }

    return data;
};

export const statusDonasi = [
    { value: 'SETTLE', name: 'SETTLE' },
    // { value: 'COLLECT', name: 'COLLECT' },
    { value: 'DRAFT', name: 'DRAFT' },
    { value: 'COMMIT', name: 'COMMIT' },
    // { value: 'RECOG', name: 'RECOG' },
    // { value: 'VOID', name: 'VOID' },
    { value: 'REQUEST_VOID', name: 'REQUEST DELETE' },
    { value: 'NOT_VOID', name: 'TIDAK DELETE' },
]

